import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  CircularProgress,
  TextField,
  IconButton,
} from '@mui/material'
import { isEqual } from 'lodash'
import { memo, useState } from 'react'
import { metodoPrograma } from '../../../components/api'
import CloseIcon from '@mui/icons-material/Close'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import { HiOutlineDocumentText } from 'react-icons/hi'

export const ModalContaAReceberNFSe = ({
  show,
  setModal,
  handleClose,
  dados,
  setRefresh,
}) => {
  const [loading, setLoading] = useState(false)
  const [empresaEmissora, setEmpresaEmissora] = useState(null)
  const [dsServico, setDsServico] = useState('')

  const emiteNFS = async () => {
    setLoading(true)
    const res = await metodoPrograma('emitirNotaFiscal', {
      idConta: dados?.[0],
      idEmpresaNotaFiscal: empresaEmissora?.[0]?.[0],
      dsServico,
    })
    if (res.status) {
      setModal(false)
      setRefresh((prev) => prev + 1)
      setEmpresaEmissora(null)
      setDsServico('')
    }
    setLoading(false)
  }

  return (
    <Dialog
      open={show}
      aria-label="close"
      keepMounted
      handleClose={handleClose}
      fullWidth={true}
      maxWidth={'lg'}
      md={{
        position: 'absolute',
        right: 80,
        top: 80,
        color: (theme) => theme.palette.grey[500],
      }}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>Nota Fiscal de Serviços</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Grid container spacing={2}>
          {dados?.[25] && (
            <Grid item xs={12}>
              <TextField
                fullWidth
                variant="outlined"
                margin="dense"
                label="Empresa Rateio"
                disabled
                value={dados?.[25]?.[1]}
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <AutoComplete
              InputLabelProps={{ shrink: true }}
              value={empresaEmissora}
              label="Prestador de serviço"
              metodo="buscaEmissorNotaFiscal"
              onChange={(_, v) => {
                setEmpresaEmissora(v)
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              margin="dense"
              label="Descrição do Serviço"
              autoFocus
              value={dsServico}
              onChange={(e) => setDsServico(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              onClick={emiteNFS}
              disabled={loading}
              variant="contained"
              color="primary"
              fullWidth
              startIcon={<HiOutlineDocumentText />}
              endIcon={
                loading ? <CircularProgress color="inherit" size={15} /> : null
              }
            >
              Emitir NFS-e
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default memo(ModalContaAReceberNFSe, isEqual)
